/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import "./CheckBox.scss";
import { cn } from "tailwind-variants";

export default function CheckBox({
  style = "default",
  label = "",
  disable = false,
  children,
  ...restProps
}: any) {
  function dynamicClasses() {
    return cn(
      style === "gray" && "check-box--gray",
      style === "reverse-gray" && "check-box--reverse-gray",
      style === "app-gray" && "check-box--app-gray"
    );
  }

  return (
    <label
      {...restProps}
      className={cn("check-box scope-ecd8145a", dynamicClasses(), restProps.className)}
      data-testid="check-box"
    >
      {children}
      <span
        className={cn("check-box__slider scope-ecd8145a", disable && "check-box__slider--disabled")}
      />
      {label ? (
        <span
          className={cn("check-box__label scope-ecd8145a", disable && "check-box__label--disabled")}
        >
          {label}
        </span>
      ) : null}
    </label>
  );
}
